import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  PrintsendShiftHost (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  salePosDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/pos/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleCreditDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/credit/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleHoldDetail (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/holdbill/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  saleSummary (URL, header, body, success, error) {
    Vue.axios.post(URL + 'sale/v1/report/total/daily', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  expenseReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'company/v1/report/expense', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  profitReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'stock/v1/report/profit/item/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  movementReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'stock/v1/report/tran/itemtoitem', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  stockReport (URL, header, body, success, error) {
    Vue.axios.post(URL + 'stock/v1/report/stock/remain', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_report.js